"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FieldLabelText = void 0;
var _react = _interopRequireDefault(require("react"));
var _Tooltip = require("../../UIElements/Tooltip/Tooltip");
var _formFieldPropTypes = require("../../../propTypes/formFieldPropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const FieldLabelText = _ref => {
  let {
    label,
    labelId,
    inputId,
    srInstruction,
    labelTooltip,
    hideLabel,
    validation
  } = _ref;
  const isRequired = validation && validation.required;
  return /*#__PURE__*/_react.default.createElement("span", {
    id: "".concat(labelId, "_label"),
    className: "".concat(hideLabel ? 'sr-only' : 'labelText', " ").concat(isRequired ? 'mandatory' : '', " ").concat(labelTooltip ? 'labelDecoration' : '')
  }, label, labelTooltip && /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    triggerId: "".concat(inputId, "_tooltip"),
    customTrackingData: {
      tooltipForLabel: {
        label
      }
    }
  }, labelTooltip), srInstruction && /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, srInstruction));
};
exports.FieldLabelText = FieldLabelText;
FieldLabelText.propTypes = _formFieldPropTypes.FieldLabelTextPropTypes;
var _default = exports.default = FieldLabelText;